import { maplibreZoomToNaverZoom } from "../../shared/naver-map.ts";

export interface LngLat {
  lng: number;
  lat: number;
}

export interface NaverStreetViewPov {
  pan: number;
  tilt: number;
  fov: number;
}

const MERCATOR_R = 6378137;

/** Web Mercator meters (EPSG:3857), matching map.naver.com `c` coordinates. */
export function lngLatToMercatorMeters(lng: number, lat: number): { x: number; y: number } {
  const x = (lng * Math.PI * MERCATOR_R) / 180;
  const clampedLat = Math.max(Math.min(lat, 85.05112878), -85.05112878);
  const y = MERCATOR_R * Math.log(Math.tan(Math.PI / 4 + (clampedLat * Math.PI) / 360));
  return { x, y };
}

export function naverMapCenterParam(lng: number, lat: number, maplibreZoom: number): string {
  const { x, y } = lngLatToMercatorMeters(lng, lat);
  const z = maplibreZoomToNaverZoom(maplibreZoom);
  return `${x},${y},${z.toFixed(2)},0,0,0,dh`;
}

export function naverStreetViewPanoParam(
  panoId: string,
  pov: NaverStreetViewPov = { pan: 0, tilt: 0, fov: 100 },
): string {
  return `${panoId},${pov.pan},${pov.tilt},${pov.fov},Float`;
}

/** Naver Map URL with street-view panorama at the map center. */
export function naverStreetViewTabUrl(
  center: LngLat,
  maplibreZoom: number,
  panoId: string,
  pov?: NaverStreetViewPov,
): string {
  const c = naverMapCenterParam(center.lng, center.lat, maplibreZoom);
  const p = naverStreetViewPanoParam(panoId, pov);
  return `https://map.naver.com/p/?c=${encodeURIComponent(c)}&p=${encodeURIComponent(p)}`;
}

/** Naver Map URL at the map center (no street view). */
export function naverMapTabUrl(center: LngLat, maplibreZoom: number): string {
  const c = naverMapCenterParam(center.lng, center.lat, maplibreZoom);
  return `https://map.naver.com/p/?c=${encodeURIComponent(c)}`;
}
